export default __webpack_public_path__ + "static/media/advisor.303d60b4.png";